// Moon-sighting corrections for the tabular Hijri calendar. Iran's official
// months follow observation, so a month regularly starts a day off the
// calculation. Each entry shifts the START of one Hijri month relative to the
// tabular result:
//
//   [hy, hm, +1]  the month began one day LATER than calculated
//   [hy, hm, -1]  the month began one day EARLIER than calculated
//   [hy, hm,  0]  the month began exactly as calculated
//
// Only deviating months need an entry; everything else stays tabular. Note a
// shift also changes the lengths of the surrounding months — the hijri service
// accounts for that.
//
// This list is the built-in fallback, compiled into the app, and the lowest
// priority tier: services/hijri-adjustments.ts lets a downloaded list replace
// any month here (including back to 0), so a correction can ship without an
// app release. Fill from official announcements (Tehran University Geophysics
// Institute calendar).
export type HijriAdjustment = [hy: number, hm: number, shift: number]

// Derived from the official 1405 calendar: each start below reproduces the
// published Gregorian date of that month's religious occasions.
export const BUILT_IN_ADJUSTMENTS: HijriAdjustment[] = [
    [1447, 10, 1], // شوال — began 2026-03-21 (عید فطر, coinciding with نوروز)
    [1447, 11, 1], // ذی‌القعده — began 2026-04-19
    [1448, 1, -1], // محرم — began 2026-06-16 (عاشورا on 4 تیر)
    [1448, 2, -1], // صفر — began 2026-07-16 (اربعین on 13 مرداد)
    [1448, 3, -1], // ربیع‌الاول — began 2026-08-14
    [1448, 4, -1], // ربیع‌الثانی — began 2026-09-13
    [1448, 5, -1], // جمادی‌الاولی — began 2026-10-12
    [1448, 6, -1], // جمادی‌الثانیه — began 2026-11-11
    // رجب (2026-12-11), شعبان (2027-01-10), رمضان (2027-02-08) and شوال
    // (2027-03-10, عید فطر on 19 اسفند) fall on the tabular dates, so they need
    // no entry. Checked against the published holidays: 13 رجب on 2 دی,
    // 27 رجب on 16 دی, 15 شعبان on 4 بهمن, 21 رمضان on 9 اسفند, 1 شوال on 19 اسفند.
]
